import { Badge, type BadgeProps } from "@mantine/core"
import { useTranslation } from "react-i18next"
import type { TSession } from "@/types/activities"

const colors = {
  pending: "gray",
  in_progress: "blue",
  confirmed: "cyan",
  ready: "blue",
  finished: "green",
  canceled: "red",
  declined: "red",
}

export function SessionState({ state, ...props }: BadgeProps & Pick<TSession, "state">) {
  const { t } = useTranslation()
  return (
    <Badge color={colors[state]} {...props}>
      {t(state)}
    </Badge>
  )
}
